var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "translation-input",
      class: { "trp-highlight-unsaved-changes": _vm.highlightUnsavedChanges }
    },
    [
      _vm.inputType == "textarea"
        ? _c("div", { staticClass: "trp-translation-input-parent" }, [
            _c("textarea", {
              ref: "textarea",
              staticClass: "trp-translation-input trp-textarea",
              attrs: { readonly: _vm.readonly },
              domProps: { value: _vm.getValue() },
              on: {
                input: function($event) {
                  _vm.updateValue()
                }
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inputType == "input"
        ? _c("div", { staticClass: "trp-translation-input-parent" }, [
            _c("input", {
              staticClass: "trp-translation-input trp-input",
              attrs: { readonly: "", type: "text" },
              domProps: { value: _vm.getValue() }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.inputType == "inputmedia"
        ? _c(
            "div",
            {
              staticClass: "trp-translation-input-parent trp-input-media-parent"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.inputType == "inputmedia",
                    expression: "inputType == 'inputmedia'"
                  }
                ],
                staticClass: "trp-add-media",
                attrs: { type: "button", value: _vm.editorStrings.add_media },
                on: {
                  click: function($event) {
                    _vm.uploadMediaFrame.open()
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "trp-input-media-container" }, [
                _c("input", {
                  ref: "inputmedia",
                  staticClass:
                    "trp-translation-input trp-input trp-input-media",
                  attrs: {
                    type: "text",
                    placeholder: this.placeholder,
                    readonly: _vm.readonly
                  },
                  domProps: { value: _vm.getValue() },
                  on: {
                    input: function($event) {
                      _vm.updateValue(null)
                    }
                  }
                })
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }